import { FileSignature, ShieldCheck, FileText } from "lucide-react";
import { Reveal } from "./Reveal";

const ITEMS = [
  {
    icon: FileSignature,
    title: "30 % d'acompte à la signature",
    text: "Le devis et le contrat signés, accompagnés d'un acompte de 30 %, réservent définitivement votre date. Règlement en ligne sécurisé par carte bancaire.",
  },
  {
    icon: FileText,
    title: "Un contrat qui détaille tout",
    text: "Horaires, matériel, options : chaque prestation est écrite noir sur blanc. Pas de zone d'ombre, pas de frais cachés.",
  },
  {
    icon: ShieldCheck,
    title: "Assurance annulation & intempéries",
    text: "Nous recommandons la souscription d'une assurance annulation et intempéries : une précaution simple pour protéger votre investissement.",
  },
];

export default function Guarantees() {
  return (
    <section id="conditions" className="relative py-28 sm:py-36" data-testid="guarantees-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="overflow-hidden rounded-[2rem] border border-cyan-400/20 bg-gradient-to-br from-[#0E1524] via-[#0B1E33] to-[#0E1524] p-8 sm:p-12 lg:p-16">
            <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
              <div className="lg:col-span-5">
                <p className="font-mono-brand text-xs uppercase tracking-[0.25em] text-cyan-400">Conditions & sérénité</p>
                <h2 className="font-display mt-4 text-3xl font-extrabold tracking-tight text-slate-50 sm:text-4xl">
                  Des conditions claires, <span className="text-gradient">une soirée sereine.</span>
                </h2>
                <p className="mt-5 text-base leading-relaxed text-slate-400">
                  La confiance se construit sur des engagements simples et vérifiables. Voici les
                  nôtres.
                </p>
              </div>
              <div className="space-y-8 lg:col-span-7">
                {ITEMS.map((item, i) => (
                  <Reveal key={item.title} delay={0.1 + i * 0.1}>
                    <div className="flex items-start gap-5" data-testid={`guarantee-item-${i + 1}`}>
                      <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-brand-gradient">
                        <item.icon size={22} className="text-[#04121f]" />
                      </div>
                      <div>
                        <h3 className="font-display text-lg font-bold text-slate-100">{item.title}</h3>
                        <p className="mt-1.5 text-sm leading-relaxed text-slate-400">{item.text}</p>
                      </div>
                    </div>
                  </Reveal>
                ))}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
